import React from "react";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {Link} from "react-router-dom";
import ReactTable from "react-table";
import {Button} from "reactstrap";
import moment from "moment";
import {confirmAlert} from "react-confirm-alert";
import {PrintBarcodeModal} from '../../containers/Print';
import ProductLong from "components/Labels/ProductLong";
import ProductShort from "components/Labels/ProductShort";
import CollectionOverride from "components/CollectionOverride";
import Select from "react-select";
import classNames from "classnames";



export default class Manufactureds extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Manufactureds._name, API.RequestType.READ_ALL);
		super(props, model);
		// this.state.filterTaxable = null;

	}

	printLabel = (e) => {
		const {data} = this.state;
		let pkey = e.currentTarget.id;
		let binary_id = e.currentTarget.getAttribute('data-binary-id');
		let product;
		let longBarCode, shortBarCode;

		switch (pkey) {
			case 'all':
				longBarCode = data.map((product, key) => <ProductLong key={key} product={product}/>)
				shortBarCode = data.map((product, key) => <ProductShort key={key} product={product}/>)
				break;
			default: {
				pkey = parseInt(pkey);
				product = data.find((item) => item.pkey === pkey && item.binary_id === binary_id);
				longBarCode = <ProductLong product={product}/>
				shortBarCode = <ProductShort product={product}/>
			}
		}

		confirmAlert({
			customUI: ({onClose}) => {
				return (
					<PrintBarcodeModal
						onClose={onClose}
						longBarCode={longBarCode}
						shortBarCode={shortBarCode}
					/>
				);
			}
		});
	};

	clearFilters = () => {
		this.setState({
			key: Math.random(),
			filter: {},
			search: '',
			startDate: '',
			endDate: '',
			filterTaxable: '',
		});
		let path = window.location.pathname.replaceAll('/', ' ').titleCase().replaceAll(' ', '');
		localStorage.removeItem('table-preferences-' + path);
	}


	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "ID",
				accessor: "pkey",
			},
			{
				Header: "SKU",
				accessor: "sku",
			},
			{
				Header: "Type",
				accessor: "type",
			},
			{
				Header: "Model",
				accessor: "model",
			},
			{
				Header: "Serial",
				accessor: "serial_number",
			},
			{
				Header: "Manufacturer",
				id: 'manufacturer',
				/** @param {Manufactureds_Object} obj */
				accessor: obj => (obj.manufacturer ? obj.manufacturers.name : obj.manufacturer_other)
			},
			{
				Header: "Caliber",
				id: 'caliber',
				/** @param {Manufactureds_Object} obj */
				accessor: obj => (obj.caliber ? obj.calibers.name : obj.caliber_other)
			},
			{
				Header: "Status",
				id: 'status',
				/** @param {Manufactureds_Object} obj */
				accessor: obj => (obj.status ? obj.product_statuses.name : "")
			},
			{
				Header: "Location",
				id: 'location',
				/** @param {Manufactureds_Object} obj */
				accessor: obj => (obj.location ? obj.locations.name_display || obj.locations.name : "")
			},
			{
				Header: "Mfg. Date",
				id: "acquisition_date",
				width: 160,
				/** @param {Manufactureds_Object} obj */
				accessor: obj => {
					return obj.acquisition_date ? moment(obj.acquisition_date)
						.local()
						.format("MM/DD/YYYY") : 'Never Acquired'
				}
			},
			{
				Header: "Dispo. Date",
				id: "disposition_date",
				width: 160,
				/** @param {Manufactureds_Object} obj */
				accessor: obj => {
					return obj.disposition_date ? moment(obj.disposition_date)
						.local()
						.format("MM/DD/YYYY") : 'Never Disposed'
				}
			},
			{
				Header: "Sale Price",
				accessor: "price_sale",
			},
			{
				Header: "Taxable",
				id: "taxable",
				accessor: obj => obj.taxable ? 'True' : 'False',
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Button
								id={props.original.pkey}
								data-binary-id={props.original.binary_id}
								color="blue-hoki"
								size="sm"
								block={true}
								onClick={this.printLabel}
							>
								<i className="fa fa-print"/>
							</Button>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							{/*is this supposed to go to manufactured?*/}
							<Link to={`/products/${props.original._id}`}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<i className={"fa fa-pencil"}/></Button>
							</Link>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={`/products/${props.original._id}#history`}>
								<Button color="default" size={"sm"} block={true}>
									<i className={"fa fa-file-text-o"}/></Button>
							</Link>
						</span>
					);
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Manufactured Products', "")}
								{this.renderDateRangeSearch()}
								<div className="statusFilter" style={{width: '110px'}}>
									<Select
										styles={this.customStyles}
										className={classNames('basic-single', {hasSelection: this.state.filter.used_firearm != null && this.state.filter.used_firearm.length})}
										classNamePrefix="select"
										onChange={this.doFilter}
										value={this.state.filterTaxable}
										isClearable={true}
										isSearchable={true}
										name="taxable"
										placeholder={"Taxable..."}
										options={[
											{value: null, label: 'All'},
											{value: false, label: 'Non-Taxable'},
											{value: true, label: 'Taxable'},
										]}
									/>
								</div>
								{this.renderHeaderRight("Manufactured Products", columns)}
								<div className="ml-auto refresh">
									<button id="all" onClick={this.printLabel} className="btn btn-default">
										Print All Labels
									</button>
								</div>

							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							defaultPageSize={limit}
							pageSize={limit}
							pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
